module.exports = __webpack_public_path__ + "static/media/AJU.6cea1291.png";